export enum ToastType {
  Info = 'info',
  Success = 'success',
  Danger = 'danger'
}
